module.exports = __webpack_public_path__ + "static/bat-8d532f76034e19db95d4304ffd1d5839.jpeg";